import React, { ReactNode } from 'react';
import styles from './AuthCard.module.scss';
import { LoadingOverlay } from '@tcc-online/common-components';
import { css, cx } from '@emotion/css';
import { useTheme } from '@tcc-online/react-theme-provider';

type AuthCardProps = {
    children?: ReactNode;
    header?: ReactNode;
    footer?: ReactNode;
    isLoading?: boolean;
    classNames?: {
        card?: string;
        content?: string;
    };
};

export default function AuthCard(props: AuthCardProps) {
    const { children, header, footer, isLoading, classNames = {} } = props;
    const [theme] = useTheme();

    return (
        <div
            className={cx(
                styles.card,
                classNames?.card,
                css({
                    backgroundColor: theme.surfaceColor,
                    borderRadius: theme.borderRadius,
                }),
            )}
        >
            <LoadingOverlay isLoading={isLoading} />
            {header}
            <div className={cx(styles.content, classNames?.content)}>
                {children}
            </div>
            {footer}
        </div>
    );
}
